<div *ngIf="(raceSyncProgress$ | async) as syncProgress" class="sync-progress-bar"
     [class.sync-complete]="syncProgress?.percent == 100"
     [hidden]="!syncProgress.display"
>
  <div class="bar" [style.width.%]="syncProgress?.percent"></div>
  <div class="label" *ngIf="syncProgress?.lastLapTime">
    Live sync: <b>{{syncProgress?.percent}}%</b>,
    laps: <b>{{syncProgress?.lapsCount}}</b>,
    last at: <b>{{syncProgress?.lastLapTime.toDate() | date:'HH:mm:ss'}}</b>
  </div>
  <div class="label" *ngIf="!syncProgress?.lastLapTime">
    Live sync: <b>0%</b>
  </div>
</div>
